/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EntityTypeEnum } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PresignedUrlResponse } from '../models';
// @ts-ignore
import type { S3BlobCategory } from '../models';
/**
 * BlobDataApi - axios parameter creator
 * @export
 */
export const BlobDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get signed url for blob data, from the blob storage
         * @summary Download blob data
         * @param {S3BlobCategory} blobCategory 
         * @param {string} blobId 
         * @param {EntityTypeEnum} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBlob: async (blobCategory: S3BlobCategory, blobId: string, entityType?: EntityTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blobCategory' is not null or undefined
            assertParamExists('downloadBlob', 'blobCategory', blobCategory)
            // verify required parameter 'blobId' is not null or undefined
            assertParamExists('downloadBlob', 'blobId', blobId)
            const localVarPath = `/api/v1/blob/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (blobCategory !== undefined) {
                localVarQueryParameter['blobCategory'] = blobCategory;
            }

            if (blobId !== undefined) {
                localVarQueryParameter['blobId'] = blobId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a presigned url for a blob
         * @summary Get a presigned url for a blob
         * @param {S3BlobCategory} blobCategory 
         * @param {EntityTypeEnum} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUrl: async (blobCategory: S3BlobCategory, entityType?: EntityTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blobCategory' is not null or undefined
            assertParamExists('getPresignedUrl', 'blobCategory', blobCategory)
            const localVarPath = `/api/v1/blob/getPresignedUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (blobCategory !== undefined) {
                localVarQueryParameter['blobCategory'] = blobCategory;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlobDataApi - functional programming interface
 * @export
 */
export const BlobDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlobDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get signed url for blob data, from the blob storage
         * @summary Download blob data
         * @param {S3BlobCategory} blobCategory 
         * @param {string} blobId 
         * @param {EntityTypeEnum} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBlob(blobCategory: S3BlobCategory, blobId: string, entityType?: EntityTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBlob(blobCategory, blobId, entityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlobDataApi.downloadBlob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a presigned url for a blob
         * @summary Get a presigned url for a blob
         * @param {S3BlobCategory} blobCategory 
         * @param {EntityTypeEnum} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresignedUrl(blobCategory: S3BlobCategory, entityType?: EntityTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PresignedUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresignedUrl(blobCategory, entityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlobDataApi.getPresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BlobDataApi - factory interface
 * @export
 */
export const BlobDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlobDataApiFp(configuration)
    return {
        /**
         * Get signed url for blob data, from the blob storage
         * @summary Download blob data
         * @param {BlobDataApiDownloadBlobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBlob(requestParameters: BlobDataApiDownloadBlobRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.downloadBlob(requestParameters.blobCategory, requestParameters.blobId, requestParameters.entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a presigned url for a blob
         * @summary Get a presigned url for a blob
         * @param {BlobDataApiGetPresignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedUrl(requestParameters: BlobDataApiGetPresignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<PresignedUrlResponse> {
            return localVarFp.getPresignedUrl(requestParameters.blobCategory, requestParameters.entityType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BlobDataApi - interface
 * @export
 * @interface BlobDataApi
 */
export interface BlobDataApiInterface {
    /**
     * Get signed url for blob data, from the blob storage
     * @summary Download blob data
     * @param {BlobDataApiDownloadBlobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobDataApiInterface
     */
    downloadBlob(requestParameters: BlobDataApiDownloadBlobRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * Get a presigned url for a blob
     * @summary Get a presigned url for a blob
     * @param {BlobDataApiGetPresignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobDataApiInterface
     */
    getPresignedUrl(requestParameters: BlobDataApiGetPresignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<PresignedUrlResponse>;

}

/**
 * Request parameters for downloadBlob operation in BlobDataApi.
 * @export
 * @interface BlobDataApiDownloadBlobRequest
 */
export interface BlobDataApiDownloadBlobRequest {
    /**
     * 
     * @type {S3BlobCategory}
     * @memberof BlobDataApiDownloadBlob
     */
    readonly blobCategory: S3BlobCategory

    /**
     * 
     * @type {string}
     * @memberof BlobDataApiDownloadBlob
     */
    readonly blobId: string

    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof BlobDataApiDownloadBlob
     */
    readonly entityType?: EntityTypeEnum
}

/**
 * Request parameters for getPresignedUrl operation in BlobDataApi.
 * @export
 * @interface BlobDataApiGetPresignedUrlRequest
 */
export interface BlobDataApiGetPresignedUrlRequest {
    /**
     * 
     * @type {S3BlobCategory}
     * @memberof BlobDataApiGetPresignedUrl
     */
    readonly blobCategory: S3BlobCategory

    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof BlobDataApiGetPresignedUrl
     */
    readonly entityType?: EntityTypeEnum
}

/**
 * BlobDataApi - object-oriented interface
 * @export
 * @class BlobDataApi
 * @extends {BaseAPI}
 */
export class BlobDataApi extends BaseAPI implements BlobDataApiInterface {
    /**
     * Get signed url for blob data, from the blob storage
     * @summary Download blob data
     * @param {BlobDataApiDownloadBlobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobDataApi
     */
    public downloadBlob(requestParameters: BlobDataApiDownloadBlobRequest, options?: RawAxiosRequestConfig) {
        return BlobDataApiFp(this.configuration).downloadBlob(requestParameters.blobCategory, requestParameters.blobId, requestParameters.entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a presigned url for a blob
     * @summary Get a presigned url for a blob
     * @param {BlobDataApiGetPresignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobDataApi
     */
    public getPresignedUrl(requestParameters: BlobDataApiGetPresignedUrlRequest, options?: RawAxiosRequestConfig) {
        return BlobDataApiFp(this.configuration).getPresignedUrl(requestParameters.blobCategory, requestParameters.entityType, options).then((request) => request(this.axios, this.basePath));
    }
}

